const images = {
    slide1: {
      max: require('./Banner_1_1600х200.jpg'),
      min: require('./Banner_1_800х200.jpg'),    
      mobile: require('./Banner_1_400х150.jpg'),
    },
    slide2: {
      max: require('./Banner_2_1600х200.jpg'),
      min: require('./Banner_2_800х200.jpg'),    
      mobile: require('./Banner_2_400х150.jpg'),
      
    },
    slide3: {
      max: require('./Banner_3_1600х200.jpg'),
      min: require('./Banner_3_800х200.jpg'),    
      mobile: require('./Banner_3_400х150.jpg'),
    },
    slide4: {
      max: require('./Banner_4_1600х200.jpg'),
      min: require('./Banner_4_800х200.jpg'),    
      mobile: require('./Banner_4_400х150.jpg'),
    }
  };

  /*
  max: 1600*200 px
  min: 800*200 px
  mobile:400*150 px

  */

  export default images;